var map = {
	"./american-express.svg": 91460,
	"./apple-pay.svg": 70642,
	"./bank.svg": 51431,
	"./blik-logo.svg": 2465,
	"./citadele-bank.png": 79867,
	"./default.svg": 64936,
	"./google-pay-logo-2-dark.svg": 34927,
	"./google-pay-logo-2.svg": 55638,
	"./google-pay-logo.svg": 16899,
	"./google-pay.svg": 77805,
	"./ideal.svg": 47792,
	"./luminor-bank.png": 74616,
	"./mastercard.svg": 60269,
	"./medicinos-bank.png": 3299,
	"./revolut-bank.png": 38627,
	"./seb-bank.png": 70526,
	"./siauliu-bank.png": 94712,
	"./swedbank-bank.png": 35981,
	"./visa.svg": 74438
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 71707;